import React, { useEffect } from 'react';

export default function GalleryModal({ images, currentIndex, isOpen, onClose, onPrev, onNext }) {
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };

    window.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose, onPrev, onNext]);

  if (!isOpen || !images || images.length === 0) return null;

  const currentImage = images[currentIndex];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-asphalt-950/95 p-4 backdrop-blur-sm">
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-asphalt-800/80 text-white hover:bg-safety-orange transition-colors duration-200"
        aria-label="Luk galleri"
      >
        <i className="fa-solid fa-xmark text-xl"></i>
      </button>

      {/* Prev button */}
      <button
        onClick={onPrev}
        className="absolute left-4 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-asphalt-800/80 text-white hover:bg-safety-orange transition-colors duration-200"
        aria-label="Forrige billede"
      >
        <i className="fa-solid fa-chevron-left text-xl"></i>
      </button>

      {/* Next button */}
      <button
        onClick={onNext}
        className="absolute right-4 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-asphalt-800/80 text-white hover:bg-safety-orange transition-colors duration-200"
        aria-label="Næste billede"
      >
        <i className="fa-solid fa-chevron-right text-xl"></i>
      </button>

      {/* Image container */}
      <div className="relative max-h-[85vh] max-w-[90vw] overflow-hidden rounded-lg shadow-2xl">
        <img
          src={`https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=85,format=auto/${currentImage.replace('https://assets.auxodev.dk/', '')}`}
          alt={`Galleri billede ${currentIndex + 1}`}
          className="max-h-[85vh] max-w-[90vw] object-contain"
        />
        
        {/* Counter */}
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 rounded-full bg-asphalt-900/80 px-4 py-1.5 text-xs font-medium text-white tracking-wider">
          {currentIndex + 1} / {images.length}
        </div>
      </div>

      {/* Click outside to close */}
      <div className="absolute inset-0 -z-10" onClick={onClose}></div>
    </div>
  );
}
